export { Segment } from './segment';
export type { SegmentProps } from './segment';
